import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSettingsSelector } from 'features/account_settings/selectors';
import { fetchUserSettings, toggleSharedEventNotificationOption } from 'features/account_settings/slice';
const containerIsDesktopUpCss = "cubpujz";
const containerCss = "c1afer7f";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const subheaderCss = "s7vpwuf";
const Subheader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subheaderCss, props.className)} />;
});
const switchContainerCss = "s64ylng";
const SwitchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(switchContainerCss, props.className)} />;
});
export const SharedEventNotificationSection = () => {
  const dispatch = useDispatch();
  const {
    sharedEventNotificationEnabled,
    isLoading
  } = useSelector(userSettingsSelector);
  useEffect(() => {
    dispatch(fetchUserSettings());
  }, [dispatch]);
  const handleChange = () => {
    dispatch(toggleSharedEventNotificationOption());
  };
  return <Container>
      <Subheader>{I18n.t('publisher.account_settings.communication_settings.added_to_event_types')}</Subheader>
      <SwitchContainer>
        <label htmlFor="shared-event-notification-switch">
          <SwitchInput id="shared-event-notification-switch" checked={sharedEventNotificationEnabled} onChange={() => handleChange()} disabled={isLoading} aria-label={I18n.t('publisher.account_settings.communication_settings.added_to_event_types_toggle_label')} />
        </label>
        {I18n.t('publisher.account_settings.communication_settings.added_to_event_types_toggle_label')}
      </SwitchContainer>
    </Container>;
};

require("./shared_event_notification_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared_event_notification_section.js");